import useCachedAdminConsoleData from "../../../../hooks/redux/useCachedAdminConsoleData";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Breakpoint } from "@mui/system/createTheme/createBreakpoints";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import { hide } from "../../../../store/redux/slice/Sidebars/adminConsoleSidebar";
import { Box } from "@mui/material";
import { SidebarRenderer } from "@duosoftbg/nacid-components";
import { sidebarWidth } from "../../../../config/sidebar/sidebarData";
import styled from "styled-components";

const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    width: ${sidebarWidth}px;
    flex-shrink: 0;
  }
`;

const AdminConsoleSidebar = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const { data } = useCachedAdminConsoleData();
  const matchesXl = useMediaQuery(theme.breakpoints.up("xxl" as Breakpoint));
  const isOpen = useAppSelector((state) => state.Sidebars.adminConsoleSidebar.open);

  function handleClose() {
    dispatch(hide());
  }

  return (
    <Drawer>
      <Box sx={{ display: "block" }}>
        <SidebarRenderer
          variant={matchesXl ? "persistent" : "temporary"}
          isOpen={isOpen}
          onClose={handleClose}
          PaperProps={{
            style: {
              width: sidebarWidth,
            },
          }}
          items={data}
          type={"common"}
        />
      </Box>
    </Drawer>
  );
};

export default AdminConsoleSidebar;
